// import { createStore, combineReducers, applyMiddleware } from "redux";
// import { composeWithDevTools } from "redux-devtools-extension";

// import { configureStore } from "@reduxjs/toolkit";

// import thunk from "redux-thunk";

// import { authLoginReducer, authRegisterReducer } from "./reducers/authReducer";
// import { movieReducer } from "./reducers/movieReducer";
// import { accountReducer } from "./reducers/customerReducer";
// import { seriesReducer } from "./reducers/seriesReducer";
// import { episodeReducer } from "./reducers/episodeReducer";
// import { adminReducer } from "./reducers/adminReducer";

// // const reducer = combineReducers({
// //   userStore: authLoginReducer,
// //   newUserStore: authRegisterReducer,
// // movieStore: movieReducer,
// // seriesStore: seriesReducer,
// // accountStore: accountReducer,
// // episodeStore: episodeReducer,
// // adminStore: adminReducer,
// // });

// const userLoggedFromLStore = localStorage.getItem("user")
//   ? JSON.parse(localStorage.getItem("user"))
//   : {};

// const initialState = {
//   userStore: { user: userLoggedFromLStore },
// };

// const middleware = [thunk];

// // const store = createStore(
// //   reducer,
// //   initialState,
// //   composeWithDevTools(applyMiddleware(...middleware))
// // );

// const store = configureStore({
//   reducer: {
//     userStore: authLoginReducer,
//   },
//   initialState,
//   // middleware: (getDefaultMiddleware) =>
//   //   getDefaultMiddleware().concat(middleware),
//   // enhancers: [monitorReducersEnhancer],
// });

// export default store;

// // import {
// //   configureStore,
// //   combineReducers,
// //   applyMiddleware,
// // } from "@reduxjs/toolkit";

// // import monitorReducersEnhancer from "./enhancers/monitorReducers";
// // import loggerMiddleware from "./middleware/logger";
// // const store = configureStore({
// //   reducer: {
// //     loginStore: loginReducer,
// //     registerStore: registerReducer,
// //     movieStore: movieReducer,
// //     seriesStore: seriesReducer,
// //     accountStore: accountReducer,
// //     episodeStore: episodeReducer,
// //     homeStore: homeReducer,
// //   },
// //   middleware: (getDefaultMiddleware) =>
// //     getDefaultMiddleware().concat(loggerMiddleware),
// //   preloadedState,
// //   enhancers: [monitorReducersEnhancer],
// // });

import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import thunk from "redux-thunk";

import { authLoginReducer, authRegisterReducer } from "./reducers/authReducer";
import { accountReducer } from "./reducers/customerReducer";
import { adminReducer } from "./reducers/adminReducer";
import { categoryReducer } from "./reducers/categoryReducer";
import { interestReducer } from "./reducers/interestReducer";
import { walletStatementReducer } from "./reducers/walletReduced";
import { getStoredUser } from "../utils/storedUser";
import globalReducer from "../state";
import { api } from "../state/api";

const rootReducer = combineReducers({
  global: globalReducer,
  [api.reducerPath]: api.reducer,
  userStore: authLoginReducer,
  newUserStore: authRegisterReducer,
  accountStore: accountReducer,
  adminStore: adminReducer,
  categotyStore: categoryReducer,
  interest: interestReducer,
  walletStatement: walletStatementReducer

  // Add other reducers here if needed
});

const userLoggedFromLStore = getStoredUser({});

const initialState = {
  userStore: { user: userLoggedFromLStore }
  // Add initial state for other reducers here if needed
};

const middleware = [thunk, api.middleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: [...middleware], // If you want to add more middleware, do [...middleware, additionalMiddleware]
  // devTools: process.env.NODE_ENV !== "production",
  preloadedState: initialState
});

export default store;
